export enum ScheduleFrequency {	
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
	Quarterly = 91,
	HalfYearly = 182,
	Yearly = 365,
}